import { useContext } from 'react';

import { useMutation } from '@apollo/client';
import { IContextMenuItem } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { DELETE_TASK, GET_TASKS } from 'schemas';
import { TTask } from 'types';

import s from './ContextMenuItems.module.scss';

export const useContextMenuItems = (
  setTaskForEdit: (task: TTask) => void
): Array<IContextMenuItem<TTask>> => {
  const { t } = useContext(LocalizationContext);

  const [deleteTask] = useMutation(DELETE_TASK, {
    refetchQueries: [GET_TASKS],
    awaitRefetchQueries: true,
    onError: console.error,
  });

  return [
    {
      key: 'edit',
      text: t('edit'),
      iconName: 'EditIcon',
      onClick: (data) => {
        setTaskForEdit(data);
      },
    },
    {
      key: 'delete',
      text: t('delete'),
      iconName: 'BucketIcon',
      onClick: (data) => deleteTask({ variables: { id: data.id } }),
      className: s['remove'],
    },
  ];
};
